import React from 'react';
import humanLogo from '../../human.svg';

function AddNetworkButton() {
  const addEarthNetwork = async () => {
    try {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: `0x${Number(process.env.REACT_APP_EARTH_CHAIN_ID || '505').toString(16)}`,
          chainName: 'Earth Network',
          nativeCurrency: {
            name: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_NAME || 'Human',
            symbol: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_SYMBOL || 'HUMAN',
            decimals: parseInt(process.env.REACT_APP_EARTH_NATIVE_CURRENCY_DECIMALS || '18', 10)
          },
          rpcUrls: [process.env.REACT_APP_EARTH_RPC_URL || 'https://main-rpc.earth.ooo'],
          blockExplorerUrls: [process.env.REACT_APP_EARTH_EXPLORER_URL || 'https://scan.earth.ooo']
        }]
      });
      console.log('Earth network added successfully');
    } catch (error) {
      console.error('Failed to add Earth network:', error);
    }
  };

  return (
    <button className="add-network-button" onClick={addEarthNetwork}>
      <img src={humanLogo} alt="Earth Network" />
      Add Earth Network
    </button>
  );
}

export default AddNetworkButton;